import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { Flowbite } from "flowbite-react";
import { PrimaryTheme } from "./theme";
import { QueryClientProvider } from "react-query";
import { queryClient } from "./data/queryClient";
import i18n from "./i18n";
import { I18nextProvider } from "react-i18next";
import { UserProvider } from "./context/UserContext";
import { WorkspaceProvider } from "./context/WorkspaceContext";
import { CacheProvider } from "./context/CacheContext";
import { DarkModeProvider } from "./context/DarkModeContext";
import { NotificationProvider } from "./context/NotificationContext";
import { OrdersRealtimeProvider } from "./context/OrdersRealtimeContext";
import { WorkspaceDataProvider } from "./data/WorkspaceDataProvider";
import { WorkspaceActivityReporter } from "./components/WorkspaceActivityReporter";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <Flowbite theme={{ theme: PrimaryTheme }}>
        <BrowserRouter>
          <UserProvider>
            <DarkModeProvider>
              <WorkspaceProvider>
                <CacheProvider>
                  <QueryClientProvider client={queryClient}>
                    <OrdersRealtimeProvider>
                      <NotificationProvider>
                        <WorkspaceDataProvider>
                          <WorkspaceActivityReporter />
                          <App />
                        </WorkspaceDataProvider>
                      </NotificationProvider>
                    </OrdersRealtimeProvider>
                  </QueryClientProvider>
                </CacheProvider>
              </WorkspaceProvider>
            </DarkModeProvider>
          </UserProvider>
        </BrowserRouter>
      </Flowbite>
    </I18nextProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
